import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { take } from 'rxjs/operators';
import App from '../../helpers/app';
import { WhatsAppService, MensagemEnviada } from '../../shared/services/whatsapp.service';

interface NumeroResumo {
  destinatario: string;
  totalMensagens: number;
}

@Component({
  selector: 'app-whatsapp-numeros',
  templateUrl: './whatsapp-numeros.component.html',
  styleUrls: ['./whatsapp-numeros.component.scss']
})
export class WhatsappNumerosComponent implements OnInit {
  numeros: NumeroResumo[] = [];
  totalRegistros = 0;
  page = 1;
  pageSize = 10;
  Math = Math;

  constructor(
    private whatsapp: WhatsAppService,
    private spinner: NgxSpinnerService,
    private app: App
  ) {}

  ngOnInit() {
    this.carregarNumeros();
  }

  async carregarNumeros() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
    try {
      const res = await this.whatsapp.listarMensagens({ offset: 0, limit: 100 }).pipe(take(1)).toPromise() as { data?: MensagemEnviada[]; total?: number };
      const data: MensagemEnviada[] = res?.data ?? [];
      this.totalRegistros = res?.total ?? 0;

      const map = new Map<string, number>();
      data.forEach(m => {
        const key = (m.destinatario || '').trim();
        if (key) map.set(key, (map.get(key) || 0) + 1);
      });
      this.numeros = Array.from(map.entries())
        .map(([destinatario, totalMensagens]) => ({ destinatario, totalMensagens }))
        .sort((a, b) => b.totalMensagens - a.totalMensagens);
      this.page = 1;
    } catch (e) {
      this.numeros = [];
      await this.app.alert('Erro', 'Não foi possível carregar os números.', 'error');
    } finally {
      this.spinner.hide();
    }
  }

  get total(): number {
    return this.numeros.length;
  }

  get totalPages(): number {
    return Math.ceil(this.total / this.pageSize) || 1;
  }

  get numerosPaginados(): NumeroResumo[] {
    const start = (this.page - 1) * this.pageSize;
    return this.numeros.slice(start, start + this.pageSize);
  }

  get startItem(): number {
    return this.total === 0 ? 0 : (this.page - 1) * this.pageSize + 1;
  }

  get endItem(): number {
    return Math.min(this.page * this.pageSize, this.total);
  }

  onPageChange(p: number): void {
    this.page = p;
  }
}
